module.exports = __webpack_public_path__ + "img/features_bg_min.545d0ea8.png";